import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UIRouter, UIRouterModule } from "@uirouter/angular";
import { loginCallbackStateDeclaration, loginStateConfigFn, loginStateDeclaration } from "./login.stateconfig";
import { LogincallbackComponent } from "./logincallback.component";

@NgModule({
    imports:[
        CommonModule,
        UIRouterModule.forChild({
            states:[
                loginStateDeclaration,
                loginCallbackStateDeclaration
            ],
            config: (router: UIRouter) => {
                loginStateConfigFn(router);
            }
        })
    ],
    declarations: [
        LogincallbackComponent
    ]
})
export class LoginModule {}
